export const changePasswordFormConstraints = (
  translateKey1: string,
  translateKey2: string,
  translateKey3: string,
  translateKey4: string
): { [key: string]: any } => {
  return {
    currentPassword: {
      presence: {
        message: translateKey1,
        allowEmpty: false,
      },
    },

    newPassword: {
      length: {
        minimum: 6,
        message: translateKey2,
      },
    },

    repeatPassword: {
      presence: {
        message: translateKey3,
        allowEmpty: false,
      },
      equality: {
        attribute: 'newPassword',
        message: translateKey4,
      },
    },
  };
};
